import React from "react";
import { Link } from "gatsby";
import { slug } from "../utils";

const MyLink = ({
  text,
  linkType,
  link,
  onClick = null,
  children,
  iconLeft = true,
}) => {
  if (linkType === "internal") {
    return (
      <Link to={slug(link)} onClick={onClick}>
        {children && iconLeft && children}
        {text}
        {children && !iconLeft && children}
      </Link>
    );
  } else if (linkType === "external") {
    return (
      <a href={link} target="_blank" onClick={onClick}>
        {children && children}
        {text}
      </a>
    );
  }
};

export default MyLink;
